@charset "UTF-8";

/* src/app/global/components/global-menu/global-menu.component.scss */
:host {
  font-size: 1.4rem;
  height: 100vh;
  min-width: 60px;
  transition: min-width 0.5s linear, width 0.5s linear;
  width: 60px;
}
.cw-menu-expanded-left :host {
  min-width: 200px;
  width: 200px;
}
.cw-flex-row {
  height: auto;
}
.cw-global-menu-logo-container {
  background: rgba(0, 0, 0, 0.2);
  height: 60px;
  min-height: 60px;
  padding: 5px;
}
.cw-global-menu-logo {
  height: 50px;
  min-height: 50px;
}
.cw-global-menu-logo-small {
  height: 50px;
  min-height: 50px;
}
.cw-global-menu-list {
  -webkit-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
}
.cw-global-menu-list-item {
  cursor: pointer;
  height: 60px;
  line-height: 6rem;
}
.cw-global-menu-active {
  background: var(--color-menu-item-active, rgba(255, 255, 255, 0.2));
}
.cw-global-submenu-active {
  background: var(--color-submenu-item-active, rgba(255, 255, 255, 0.2));
}
.cw-global-menu-list-item:hover,
.cw-global-menu-toggle:hover {
  background: var(--color-menu-item-hover, rgba(255, 255, 255, 0.2));
}
.cw-global-menu-list-icon {
  font-size: 1.8rem;
  align-self: center;
  text-align: center;
  width: 60px;
}
.cw-global-menu-list-icon:hover {
  font-size: 2.2rem;
}
.cw-global-menu-list-text {
  padding-right: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  align-self: center;
  line-height: 1.2;
  width: 140px;
}
.cw-global-menu-toggle {
  cursor: pointer;
  flex: 1;
  height: 60px;
  line-height: 6rem;
  max-height: 60px;
  text-align: center;
  background: var(--color-accent);
}
.cw-global-menu-toggle .cw-global-menu-list-text {
  text-align: left;
}
.ios-device :host {
  height: 100%;
}
.cw-global-submenu {
  background: rgba(0, 0, 0, 0.2);
  animation-name: slide;
  animation-duration: 0.3s;
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
}
@keyframes slide {
  from {
    height: 0;
  }
}
.cw-global-menu-arrow-icon {
  align-self: center;
}
.cw-global-menu-list-item > span {
  display: flex;
  align-items: center;
}
.cw-global-menu-arrow-slot {
  width: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
}
.cw-global-menu-arrow-slot fa-icon {
  font-size: 1rem;
}
/*# sourceMappingURL=global-menu.component.css.map */
